// src/pages/Auditorias/components/ParecerDialog.js
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { obterParecer, descarregarFicheiro } from '../api';
import { formatarData } from '../utils/formatacao';

/**
 * Parecer final em markdown. Aberto a partir da lista e do detalhe.
 * Segue o padrão de ConferirDocumento/components/AnaliseDialog.js.
 */
const ParecerDialog = ({ auditoriaId, onClose }) => {
  const [parecer, setParecer] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (!auditoriaId) return;
    setCarregando(true);
    obterParecer(auditoriaId)
      .then(({ data }) => { setParecer(data.data); setErro(null); })
      .catch((e) => setErro(e.response?.data?.message || 'Erro ao carregar o parecer'))
      .finally(() => setCarregando(false));
  }, [auditoriaId]);

  const copiar = () => {
    if (!parecer?.conteudo) return;
    navigator.clipboard.writeText(parecer.conteudo)
      .then(() => alert('Parecer copiado para a área de transferência'))
      .catch((e) => console.error('Erro ao copiar:', e));
  };

  const descarregar = () => {
    if (!parecer) return;
    descarregarFicheiro(auditoriaId, 'artefacto', parecer.id, parecer.nome_ficheiro)
      .catch((e) => console.error('Erro no download:', e));
  };

  return (
    <div className="aud-overlay" onClick={onClose}>
      <div className="aud-modal" onClick={(e) => e.stopPropagation()}>
        <div className="aud-modal-cabecalho">
          <h3>Parecer final{parecer ? ` · ${parecer.cod_processo}` : ''}</h3>
          <button className="aud-modal-fechar" onClick={onClose} aria-label="Fechar">✖</button>
        </div>

        <div className="aud-modal-corpo">
          {carregando && <p className="aud-vazio">A carregar…</p>}

          {erro && <p className="aud-erro">{erro}</p>}

          {parecer && (
            <>
              <div className="aud-meta">
                <span>{formatarData(parecer.criado_em)}</span>
                <span>
                  cobertura {parecer.total_avaliados} de {parecer.total_ficheiros} peças
                </span>
                {parecer.total_problemas > 0 && (
                  <span className="aud-meta-alerta">
                    {parecer.total_problemas} com reparos
                  </span>
                )}
                {parecer.validacao === 'validada' && (
                  <span className="aud-badge aud-badge-ok">validada</span>
                )}
              </div>

              <div className="aud-markdown">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {parecer.conteudo}
                </ReactMarkdown>
              </div>
            </>
          )}
        </div>

        {parecer && (
          <div className="aud-modal-rodape">
            <button className="aud-btn-primario" onClick={copiar}>COPIAR</button>
            <button className="aud-btn-secundario" onClick={descarregar}>DESCARREGAR .TXT</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ParecerDialog;
